import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { LocationRelatableTypeEnum } from 'src/app/enums/location-relatable-type.enum';
import { LocationsManagementComponent } from '../../../locations/locations-management/locations-management.component';

@Component({
  selector: 'app-project-locations',
  templateUrl: './project-locations.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [LocationsManagementComponent],
})
export class ProjectLocationsComponent implements OnInit {
  readonly relatable_type = LocationRelatableTypeEnum.Company;
  company_id: number | null = null;
  is_loading = true;

  private readonly company_product_id = inject(ActivatedRoute).snapshot.parent!.parent!.paramMap.get('id')!;
  private readonly api = inject(ApiService);

  ngOnInit(): void {
    this.api.getCompanyProduct(this.company_product_id).subscribe(company_product => {
      this.company_id = company_product.company_id;
      this.is_loading = false;
    });
  }
}
